import styled from "@emotion/styled";
import React from "react";
import QuestionWrapper from "./QuestionWrapper";

const StyledQuestionErrorMessage = styled.span`
  display: flex;
  margin-bottom: 6px;
  color: var(--red);
  font-size: 14px;
  font-weight: bold;
`;

const QuestionErrorMessage = (props: { children: React.ReactNode }) => {
  return (
    <QuestionWrapper>
      <StyledQuestionErrorMessage>{props.children}</StyledQuestionErrorMessage>
    </QuestionWrapper>
  );
};

export default QuestionErrorMessage;
